import md5 from "md5"
import { getUser } from "./CurrentUser/currentUserLocalStorage"

let Base_url = process.env.BASE_URL

// async function validateHuman(token) {
//   let secret = process.env.SECRET_KEY
//   let recaptchaENDPOINT = `${Base_url}/recaptcha` // // Replace with environment variables

//   try {
//     let result = await fetchData(recaptchaENDPOINT, { secret, token })
//     return result.success
//   } catch (error) {
//     console.log(error)
//   }
// }

export const handleLoginRequest = async (username, password, accountType, token) => {
  let hashedPassword = md5(password)

  
    // const Base_url = process.env.PLAY_BASE_URL

  let loginENDPOINT = `${Base_url}/login` // // Replace with environment variables

  try {
    let result = await fetchData(loginENDPOINT, {
      username,
      password: hashedPassword,
      accountType,
      token: token,
    })
    // console.log(accountType)
    return result
  } catch (error) {
    console.log(error)
  }
}
export const handleLogoutRequest = async () => {
  const userName = getUser().username

  let loginENDPOINT = `${Base_url}/logout` // // Replace with environment variables
  try {
    let result = await fetchData(loginENDPOINT, {username:userName})
    // console.log(accountType)
    return result
  } catch (error) {
    console.log(error)
  }
}

export const handleRegisterRequest = async (
  accountType,
  username,
  password,
  cpassword,
  accountNumber, 
  // token
) => {
  // console.log('reqest')
  // console.log(Base_url)
  let registerENDPOINT = `${Base_url}/register` // // Replace with environment variables

  try {
    let hashedPassword = md5(password)
    let hashedcPassword = md5(cpassword)
    let result = await fetchData(registerENDPOINT, {
      accountType,
      username,
      password: hashedPassword,
      cpassword:hashedcPassword,
      accountNumber
    })
    // console.log(result)
    return result
  } catch (error) {
    console.log(error)
  }
}

export const handleVerificationRequest = async (username, activation_code,accountType) => {
  // console.log('reqest')
  // console.log(Base_url)
  let verificationENDPOINT = `${Base_url}/verify-account` // // Replace with environment variables

  try {
    let result = await fetchData(verificationENDPOINT, {
      username,
      activation_code,
      accountType
    })
    // console.log(result)
    return result
  } catch (error) {
    console.log(error)
  }
}

export const handleForgotPassword = async (
  username,
  accountType = 'individual', // set accountType default to individual. TODO: add logic for handling account types
  // token
) => {
  // console.log('request password')
  // console.log(Base_url)
  let registerENDPOINT = `${Base_url}/send-reset-code` // // Replace with environment variables

  try {
    let result = await fetchData(registerENDPOINT, { username, accountType })
    // console.log(username)
    return result
  } catch (error) {
    console.log(error)
  }
}

export const getData = async (
  username,
  accountType = 'individual', // set accountType default to individual. TODO: add logic for handling account types
  // token
) => {
  // console.log('request password')
  // console.log(Base_url)
  let ENDPOINT = `${Base_url}/getData` // // Replace with environment variables

  try {
    let result = await fetchData(ENDPOINT, { username, accountType })
    // console.log(username)
    return result
  } catch (error) {
    console.log(error)
  }
}




export const resendOTPCode = async (
  username,
  accountType // set accountType default to individual. TODO: add logic for handling account types
) => {
  // console.log('request password')
  // console.log(Base_url)
  let registerENDPOINT = `${Base_url}/send-resend-otp` // // Replace with environment variables

  try {
    let result = await fetchData(registerENDPOINT, { username, accountType })
    // console.log(result)
    return result
  } catch (error) {
    console.log(error)
  }
}

export const handleForgotChangePassword = async (
  username,
  code,
  password,
  confirm_password,
  accountType // set accountType default to individual. TODO: add logic for handling account types
) => {
  // console.log('request password')
  // console.log(Base_url)
  let registerENDPOINT = `${Base_url}/change-password` // // Replace with environment variables

  try {
    let hashedPassword = md5(password)
    let hashedcPassword = md5(confirm_password)
    let result = await fetchData(registerENDPOINT, {
      username,
      code,
      password:hashedPassword,
      confirm_password:hashedcPassword,
      accountType
    })
    // console.log(result)
    return result
  } catch (error) {
    console.log(error)
  }
}

export const handleDefaultService = async (username, serviceID) => {
  let ENDPOINT = `${process.env.API_URL}digicare-srr-verify-ghana-card` // // Replace with environment variables
  // process.env.API_URL + "digicare-srr-verify-ghana-card"
  try {
    let result = await fetchData(ENDPOINT, { username, serviceID })
    // console.log(result)

    return result
  } catch (error) {
    console.log(error)
  }
}

export const handleAuthorization = async token => {
  // console.log(Base_url)
  let authorizationENDPOINT = `${Base_url}/authorize` // // Replace with environment variables

  try {
    let result = await fetchData(authorizationENDPOINT, { token })
    // console.log(result)
    return result
  } catch (error) {
    console.log(error)
  }
}

export const fetchData = async (
  endpoint,
  requestParams = {},
  finalResponse = {
    msg:"There was an error processing your request,please try again later"
  }
) => {
  try {
    const response = await fetch(endpoint, {
      method: 'post',
      body: JSON.stringify(requestParams),
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache'
      },
      credentials: 'include'
    })
    // const data = await response.json();
    // console.log(data)
    const { data, message } = await response.json()
    if (response.status === 200) {
      // Move response Data to the backend
      finalResponse['success'] = true
      finalResponse['data'] = data
      finalResponse['msg'] = message
      return finalResponse
    }

    finalResponse['success'] = false
    finalResponse['msg'] = message
    finalResponse['data'] = data

    return finalResponse
  } catch (error) {
    return finalResponse
  }
}
